import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { BOEScenario } from 'views/DealDashboard/BOE/types';

const getBOEScenarios = async (
    orgId: string,
    dealId?: number,
): Promise<BOEScenario[]> => {
    const params: Record<string, string> = {};
    if (dealId) {
        params.deal_id = dealId.toString();
    }

    const response = await axiosInstance.get(API_ENDPOINTS.BACK_OF_ENVELOPE(orgId), { params });
    return response.data;
};

export const useGetBOEScenarios = (
    orgId: string,
    dealId?: number,
    options?: { enabled: boolean },
) => useQuery({
    queryKey: [QUERY_KEYS.BOE.SCENARIOS, orgId, dealId],
    queryFn: () => getBOEScenarios(orgId, dealId),
    staleTime: 5000,
    ...options,
});
